var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.345 17.6899C11.9034 17.6899 13.3409 17.2067 14.5369 16.3732L18.8255 20.6617C19.055 20.8913 19.357 21 19.6711 21C20.3476 21 20.8429 20.4805 20.8429 19.8161C20.8429 19.502 20.7342 19.2 20.5047 18.9705L16.2523 14.706C17.1584 13.4859 17.6899 11.9758 17.6899 10.345C17.6899 6.29799 14.3919 3 10.345 3C6.31007 3 3 6.28592 3 10.345C3 14.392 6.29798 17.6899 10.345 17.6899ZM10.345 15.8899C7.31275 15.8899 4.80001 13.3772 4.80001 10.345C4.80001 7.30069 7.31275 4.8 10.345 4.8C13.3892 4.8 15.8899 7.30069 15.8899 10.345C15.8899 13.3772 13.3892 15.8899 10.345 15.8899Z",
    fill: "#8E8E93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying_glass.5d02ca158e5a07805bf9a55892c070ad.svg";
export { ForwardRef as ReactComponent };